import React from 'react';
import { VolumeUnit } from 'acscp/api/models/customTypes/volumeUnit';
import { LengthUnit } from 'acscp/api/models/customTypes/lengthUnit';

export const volumeUnitToHtml = (volumeUnit: VolumeUnit | null): string | JSX.Element => {
    if (!volumeUnit) {
        return '';
    }
    switch (volumeUnit) {
        case VolumeUnit.CubicFoot:
            return(
                <span>ft<sup>3</sup></span>
            );
        case VolumeUnit.CubicMetre:
            return(
                <span>m<sup>3</sup></span>
            );
    }
};

export const lengthUnitToString = (lengthUnit: LengthUnit | null): string => {
    if (!lengthUnit) {
        return '';
    }

    switch (lengthUnit) {
        case LengthUnit.Centimetre:
            return 'cm';
        case LengthUnit.Inch:
            return 'in';
    }
};
